import script from "./DAbracadabra.vue?vue&type=script&setup=true&lang=js"
export * from "./DAbracadabra.vue?vue&type=script&setup=true&lang=js"

import "./DAbracadabra.vue?vue&type=style&index=0&id=7a2523aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a2523aa"]])

export default __exports__